import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import SpzaComponent from './spzaComponent';
import Animation from './animation';
class Loader extends SpzaComponent {
    renderImpl() {
        return /*#__PURE__*/ _jsx("div", {
            className: "animation",
            children: /*#__PURE__*/ _jsx(Animation, {
                isCircular: true
            })
        });
    }
}
export { Loader as default };
